import React from 'react';
import TurbineCalculator from './TurbineCalculator.js';
import './App.css';

function App() {
  return (
    <div className="app">
      <h1>Calculating wind power</h1>
      <TurbineCalculator />
    </div>
  );
}

export default App;
